import * as Vue from "vue";
import {Component} from "vue-property-decorator";
import "./installerDetailView.styl";
const template = require("./installerDetailView.vue");

@Component({
  template: template
})
export class InstallerViewComponent extends Vue {


}

Vue.component("cmInstallerDetailView", InstallerViewComponent);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/views/installerDetailView/installerDetailView.ts